import MLabeledText from "./MLabeledText.vue";
export default MLabeledText;
